module.exports = __webpack_public_path__ + "static/img/employee-05.1ef539a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-05.png
// module id = EVTD
// module chunks = 2